import { render } from "./DataLiveIg.vue?vue&type=template&id=508ef276&scoped=true"
import script from "./DataLiveIg.vue?vue&type=script&lang=js"
export * from "./DataLiveIg.vue?vue&type=script&lang=js"

import "./DataLiveIg.vue?vue&type=style&index=0&id=508ef276&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508ef276"]])

export default __exports__